/**
 * 会话服务
 */

export interface SessionMessage {
    id: number;
    userId: string;
    sessionId: string;
    sender: number; // 1: 用户, 2: AI
    content: string;
    contentType: number;
    createdAt: string;
}

export interface PaginationInfo {
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    first: boolean;
    last: boolean;
    hasNext: boolean;
    hasPrevious: boolean;
}

export interface LastSessionResponse {
    success: boolean;
    code: number;
    message: string;
    data: SessionMessage[];
    pagination: PaginationInfo;
}

const BASE_URL = '/api';

/**
 * 获取用户上次会话
 * @param wechatOpenId - 微信OpenID
 * @param page - 页码（默认0）
 * @param size - 每页大小（默认100）
 */
export const getLastSession = async (
    wechatOpenId: string,
    page: number = 0,
    size: number = 100
): Promise<LastSessionResponse> => {
    try {
        const params = new URLSearchParams({
            wechatOpenId,
            page: page.toString(),
            size: size.toString(),
        });

        const apiUrl = `/api/we-chat/last-session?${params.toString()}`;
        console.log('获取上次会话，URL:', apiUrl);

        const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        });

        console.log('获取上次会话响应状态:', response.status, response.statusText);

        if (!response.ok) {
            const errorText = await response.text();
            console.error('获取上次会话失败:', {
                status: response.status,
                statusText: response.statusText,
                body: errorText
            });

            throw new Error(`获取会话失败: ${response.status}`);
        }

        const result = await response.json();
        console.log('获取上次会话结果:', result);

        return result;
    } catch (error) {
        console.error('获取上次会话错误:', error);
        return {
            success: false,
            code: 500,
            message: error instanceof Error ? error.message : '获取会话失败',
            data: [],
            pagination: {
                page: 0,
                size: 0,
                totalElements: 0,
                totalPages: 0,
                first: true,
                last: true,
                hasNext: false,
                hasPrevious: false,
            },
        };
    }
};
